import React, { createContext, useContext, useState, useEffect } from 'react';
import catalogsService from '../services/catalogs';

const CatalogsContext = createContext();

export const useCatalogs = () => {
  const context = useContext(CatalogsContext);
  if (!context) {
    throw new Error('useCatalogs debe ser usado dentro de un CatalogsProvider');
  }
  return context;
};

export const CatalogsProvider = ({ children }) => {
  const [catalogs, setCatalogs] = useState({
    categories: [],
    channels: [],
    requirements_by_channel: {}
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadCatalogs = async () => {
      try {
        setLoading(true);
        setError(null);
        const data = await catalogsService.getCatalogs();
        setCatalogs(data);
      } catch (err) {
        console.error('Error al cargar catálogos:', err);
        setError('Error al cargar los catálogos');
        // Usar datos por defecto en caso de error
        setCatalogs({
          categories: [],
          channels: [],
          requirements_by_channel: {}
        });
      } finally {
        setLoading(false);
      }
    };

    loadCatalogs();
  }, []);

  // Funciones helper para obtener datos filtrados (ahora async porque llaman a la API)
  const getCategoriesByParent = async (parentId) => {
    return await catalogsService.getCategoriesByParent(parentId);
  };

  const getFormsByCategory = async (categoryId) => {
    return await catalogsService.getFormsByCategory(categoryId);
  };

  const getFieldsSchema = async (categoryId, formId) => {
    return await catalogsService.getFieldsSchema(categoryId, formId);
  };

  const channelRequiresLocation = (channelId) => {
    return catalogsService.channelRequiresLocation(channelId, catalogs.requirements_by_channel);
  };

  const value = {
    catalogs,
    loading,
    error,
    getCategoriesByParent,
    getFormsByCategory,
    getFieldsSchema,
    channelRequiresLocation,
    // Función para recargar catálogos si es necesario
    reloadCatalogs: async () => {
      try {
        setLoading(true);
        const data = await catalogsService.getCatalogs();
        setCatalogs(data);
      } catch (err) {
        setError('Error al recargar los catálogos');
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <CatalogsContext.Provider value={value}>
      {children}
    </CatalogsContext.Provider>
  );
};

export default CatalogsProvider;
